import type {FC} from 'react';

import {Observer} from 'mobx-react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import {TextInput} from '../../../../uikit/TextInput';
import * as S from './styles';

export const RequestRefundContainer: FC<Props> = ({store}) => {
  const {t} = useI18n();
  const amount = store.fields.requestedAmount;

  return (
    <S.Container>
      <S.Label>{t('shared:enter_amount')}</S.Label>
      <Observer>
        {() => (
          <S.Container>
            <TextInput
              error={amount.error ?? ''}
              inputMode="numeric"
              onChange={store.onChangeAmount}
              placeholder={t('shared:enter_requested_refund_amount')}
              ref={amount.ref}
              value={store.requestedAmountInputValue}
            />
            <S.MaxAmount>{store.maxAmountString}</S.MaxAmount>
          </S.Container>
        )}
      </Observer>
    </S.Container>
  );
};
